module.exports = __webpack_public_path__ + "static/media/cloud-computing.590ef91c.svg";